var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-heading__pic[data-v-8bd562d2] {\n  background: url(" + escape(require("../../../../../public/img/common/account_pic.png")) + ") no-repeat center center;\n  border-radius: 50%;\n  overflow: hidden;\n  position: relative;\n  background-size: contain;\n}\n.profile-heading__pic img[data-v-8bd562d2] {\n  height: 100%;\n}\n.align-text[data-v-8bd562d2] {\n  display: flex;\n  align-items: center;\n}\n", ""]);

// exports
